import { formatParams } from '../utilities';

window.__va__(app => {
  const [cfg] = app.config.files.filter(file => file.name === 'survey' && file.type === 'script');

  if (!cfg || !cfg.options) {
    console.warn('survey config is empty or missed options');
    return;
  }

  app.on('menu.survey', () => {
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'document';

    xhr.onload = () => {
      const node = xhr.responseXML.querySelector('string');

      if (node) {
        const url = node.innerHTML;
        window.open(url, '_blank');
      }
    };

    const defaultParams = {};

    xhr.open(
      'GET',
      `${cfg.options.click.url}${formatParams({ ...defaultParams, ...cfg.options.click.params })}`
    );
    xhr.send();
  });

  let isOpened = false;
  let deletedConversation = false;
  let suggestedAfterClose = false;
  // let suggested = false;
  let suggestedAfterClick = false;

  app.on('opened', () => {
    isOpened = true;
  });

  app.on('menu.deleteConversation', () => {
    deletedConversation = true;
  });

  app.on('closed', () => {
    suggestedAfterClose = true;
    if (isOpened) {
      app.emit('getStore');

      app.on('store', (_, store) => {
        const interacted =
          store.chat.messages.slice().filter(message => message.type === 1).length > 0;

        if ((interacted || deletedConversation) && suggestedAfterClose) {
          const defaultParams = {
            SessionID: store.app.sessionId
          };

          const url = `${cfg.options.close.url}${formatParams({
            ...defaultParams,
            ...cfg.options.close.params
          })}`;

          window.open(url);

          isOpened = false;
          suggestedAfterClose = false;
        }
      });
    }
  });

  app.on('survey', () => {
    suggestedAfterClick = true;
    if (isOpened) {
      app.emit('getStore');

      app.on('store', (_, store) => {
        if (suggestedAfterClick) {
          const defaultParams = {
            SessionID: store.app.sessionId
          };

          const url = `${cfg.options.close.url}${formatParams({
            ...defaultParams,
            ...cfg.options.close.params
          })}`;

          window.open(url);
          suggestedAfterClick = false;
        }
      });
    }
  });
});
